<button id="{{sasId}}"
        class="btn"
        [ngClass]="classes"
        [type]="type"
        [disabled]="disabled"
        (click)="onClick($event)"
        role="button"
        tabindex="0"
        [attr.aria-label]="text | translate"
        [attr.aria-disabled]="ariaDisabled"
        (keydown.enter)="onClick($event)">
  {{text | translate}}
</button>
